// Material 3 Components Central Registry / Barrel File
// Exports and links all modular Material components under the Components namespace
(function () {
  window.Components = window.Components || {};

  // All modular components are registered directly onto window.Components:
  // - Design Tokens: m3Colors, m3DarkColors, m3LightColors, getM3Colors, m3Shape, m3Elevation, m3Theme, getM3Theme
  // - Icons: Icon, GoogleIcon, MdIcon
  // - Buttons: Button, FilledButton, FilledTonalButton, ElevatedButton, OutlinedButton, TextButton
  // - Icon Buttons: IconButton, FilledIconButton, FilledTonalIconButton, OutlinedIconButton
  // - Cards: Card, ElevatedButtonCard, FilledCard, OutlinedCard, CardContent, CardActions
  // - Avatars: UserAvatar, getAvatarInitials
  // - Dialogs: Dialog, DialogTitle, DialogContent, DialogActions
  // - Tabs: Tabs, Tab, PrimaryTab, SecondaryTab
  // - Text Fields & Search: TextField, OutlinedTextField, FilledTextField, SearchBar, SearchField
  // - Chips: Chip, AssistChip, FilterChip, InputChip, SuggestionChip
  // - Menus: Menu, MenuItem, ListItemIcon, ListItemText
  // - Progress: CircularProgress, LinearProgress
  // - Dividers: Divider
  // - Tooltips: Tooltip
  // - Selection: Switch, Checkbox, Select, Radio, RadioGroup (FormControls.js)
  // - Inputs (prepared, unused so far): Slider, Autocomplete, NumberField (FormControls.js)
  // - Feedback: Banner (inline), Snackbar (transient)
  // - Actions & Navigation: Fab, NavigationBar (compact bottom bar)
  // - Data: DataTable, DataTableContainer, DataTableHead, DataTableBody, DataTableRow, DataTableCell
  // - Views & Sections: Navbar, UserMenu, ThemePicker, AppsView, PortfolioView, AdminView, AccountView, AuthDialog
  // - Portfolio: PortfolioHub (hash router), PortfolioPageHeader, VideoWorkspace, PhotoWorkspace, UxWorkspace, CaseStudyPage, ImagePlaceholder (content comes from the API; portfolioData.js only seeds the database on the server)
  // - Dynamic Theming: M3_COLOR_SCHEMES, generateM3Colors, m3Typescale, applyM3CssVariables, resolveM3Mode, getM3Colors, getM3Theme
  // - Utilities: generateRandomPassword

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = window.Components;
  }
})();
